<template>
  <div>
    <!-- tabs栏 -->
    <div class="tabs">
      <div
        class="tabs_item"
        :class="{ activeTabs: activeTabs == index }"
        @click="changeTabs(index)"
        v-for="(item, index) in tabsList"
        :key="index"
      >
        {{ item }}
      </div>
    </div>
    <!-- 用户信息 -->
    <Info v-if="activeTabs == 0"></Info>
    <!-- 学籍信息 -->
    <SchoolRoll v-if="activeTabs == 1"></SchoolRoll>
    <!-- 账号安全 -->
    <Safety v-if="activeTabs == 2"></Safety>
  </div>
</template>
<script>
import Info from "@/components/personal/zhanghu/info.vue";
import SchoolRoll from "@/components/personal/zhanghu/schoolRoll.vue";
import Safety from "@/components/personal/zhanghu/safety.vue";
import store from "store";
export default {
  components: {
    SchoolRoll,
    Info,
    Safety,
  },
  props: ["message"],
  data() {
    return {
      activeTabs: 0,
      tabsList: ["基本信息", "学籍信息", "账号安全"],
    };
  },
  watch: {
    message(val) {
      //   this.activeTabs = val;
    },
  },
  mounted() {
    this.activeTabs = store.get("activeTabs");
  },
  methods: {
    changeTabs(i) {
      this.activeTabs = i;
      store.set("activeTabs", i);
    },
  },
};
</script>
<style lang="less">
.activeTabs {
  background-color: #029aff;
  color: #fff !important;
}
.tabs {
  width: 100%;
  height: 50px;
  border-bottom: 2px solid #029aff;
  display: flex;
  align-items: center;
  .tabs_item {
    padding: 0 30px;
    box-sizing: border-box;
    height: 100%;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    font-size: 20px;
    color: #343434;
  }
}
</style>
